export default function PricingSection() {
  const pricingItems = [
    {
      label: '30分コース',
      price: '8,000円',
      duration: '30分',
      description: '痛みのある部位を集中的に施術',
      highlight: false,
      badge: null
    },
    {
      label: '60分コース',
      price: '10,000円',
      duration: '60分',
      description: '全身をしっかり整えたい方に',
      highlight: true,
      badge: null
    },
    {
      label: '90分コース',
      price: '15,000円',
      duration: '90分',
      description: 'じっくり全身の血流を改善したい方に',
      highlight: false,
      badge: null
    },
    {
      label: '週1回メンテナンスコース',
      price: '月額24,000円',
      duration: '60分 × 月4回',
      description: '継続ケアで体を根本から整えたい方に',
      highlight: false,
      badge: 'お得'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Pricing
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            料金
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            シンプルでわかりやすい料金設定です
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {pricingItems.map((item, index) => (
            <div
              key={index}
              className={`relative rounded-3xl p-8 text-center transition-all duration-300 ${
                item.highlight
                  ? 'bg-gradient-to-br from-[#10B981] to-[#059669] shadow-2xl transform lg:-translate-y-4'
                  : 'bg-[#F0FDF4] shadow-lg hover:shadow-xl'
              }`}
            >
              {item.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="px-4 py-1 bg-[#F59E0B] text-white text-xs font-bold rounded-full whitespace-nowrap shadow-md">
                    {item.badge}
                  </span>
                </div>
              )}
              <div className={`text-base font-bold mb-4 leading-snug ${item.highlight ? 'text-white' : 'text-[#065F46]'}`}>
                {item.label}
              </div>
              <div className={`text-3xl font-bold mb-2 ${item.highlight ? 'text-white' : 'text-[#065F46]'}`} style={{ fontFamily: "'Noto Serif JP', serif" }}>
                {item.price}
              </div>
              <div className={`text-sm mb-5 ${item.highlight ? 'text-white/90' : 'text-gray-500'}`}>
                {item.duration}
              </div>
              <div className={`text-sm leading-relaxed ${item.highlight ? 'text-white/90' : 'text-gray-600'}`}>
                {item.description}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#ECFDF5] rounded-3xl p-10 max-w-4xl mx-auto">
          <div className="text-center">
            <p className="text-lg text-[#065F46] leading-relaxed mb-6">
              <strong className="font-bold">初めての方でも安心</strong>してご利用いただけます。<br className="hidden md:block" />
              お身体の状態に合わせて、最適なコースをご提案いたします。<br />
              <span className="text-base text-gray-600 mt-4 inline-block">
                ※料金は税込表示です　※保険適用外
              </span>
            </p>
            <div className="flex items-center justify-center gap-4 mt-4 pt-6 border-t border-[#A7F3D0]">
              <div className="flex items-center gap-2 text-[#065F46]">
                <i className="ri-money-yen-circle-line text-2xl text-[#10B981]"></i>
                <span className="text-base font-medium">現金</span>
              </div>
              <span className="text-[#10B981] font-bold text-lg">／</span>
              <div className="flex items-center gap-2 text-[#065F46]">
                <i className="ri-smartphone-line text-2xl text-[#10B981]"></i>
                <span className="text-base font-medium">PayPay</span>
              </div>
              <span className="text-gray-500 text-sm ml-2">がご利用いただけます</span>
            </div>
          </div>
        </div>

        {/* LINE誘導ボタン */}
        <div className="mt-12 max-w-4xl mx-auto">
          {/* 週1回コース訴求バナー */}
          <div className="bg-gradient-to-r from-[#FFFBEB] to-[#FEF3C7] border border-[#F59E0B]/30 rounded-2xl p-6 mb-8 flex flex-col md:flex-row items-center gap-5">
            <div className="flex items-center justify-center w-12 h-12 bg-[#F59E0B] rounded-full flex-shrink-0">
              <i className="ri-star-fill text-white text-xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <p className="text-[#92400E] font-bold text-base mb-1">
                週1回メンテナンスコース、気になっていますか？
              </p>
              <p className="text-[#78350F]/80 text-sm leading-relaxed">
                「続けたいけど費用が心配」「自分に合うか不安」など、どんな小さな疑問もLINEで気軽にご相談いただけます。
              </p>
            </div>
            <a
              href="https://lin.ee/uGMpYkR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#F59E0B] text-white text-sm font-bold rounded-full hover:bg-[#D97706] transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0"
            >
              <i className="ri-line-fill text-lg"></i>
              <span>週1回コースのご相談はこちら</span>
            </a>
          </div>

          {/* 通常LINE誘導 */}
          <div className="text-center">
            <p className="text-base text-gray-500 mb-5">
              コース選びに迷ったら、まずはお気軽にどうぞ
            </p>
            <a
              href="https://lin.ee/uGMpYkR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-[#06C755] text-white text-lg font-bold rounded-full hover:bg-[#05B04A] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINEで相談する</span>
              <i className="ri-arrow-right-line text-2xl"></i>
            </a>
            <p className="text-xs text-gray-400 mt-4">
              返信は通常当日〜翌日以内にお送りしています
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}